

























































































































































import Vue from "vue";
import { apiUrl } from "@/domain";
import VueUploadComponent from "vue-upload-component";
import ImageCompressor from "compressorjs";
import HeaderComponent from "@/components/HeaderComponent.vue";
import ApiService from "@/services/ApiService";
export default Vue.extend({
  name: "SingleCouncilModal",
  data() {
    return {
      council: {},
      edit: false,
      admins: [{}],
      uploadUrl: "",
      council_logo: [],
    };
  },
  components: {
    HeaderComponent,
    "file-upload": VueUploadComponent,
  },
  props: {
    id: Number,
    new: Boolean,
  },
  methods: {
    handleAvatarSuccess() {
      alert("true");
    },
    startEditing() {
      this.edit = true;
      this.admins[0] = this.council.admins[0];
    },
    test() {
      alert("test");
    },
    inputFile: function (newFile, oldFile) {
      if (newFile && oldFile && !newFile.active && oldFile.active) {
        // Get response data
        if (newFile.type.substr(0, 6) === "image/") {
          if (newFile.xhr) {
            //  Get the response status code
            const response = newFile.xhr.response;
            this.form.school_logo = response;

            setTimeout(() => {
              if (this.$refs.upload.active === false) {
                this.imagesLoading = false;
              }
            }, 500);
          }
        }
      }
      // Automatic upload
      if (
        Boolean(newFile) !== Boolean(oldFile) ||
        oldFile.error !== newFile.error
      ) {
        if (newFile.error == "") {
          this.imagesLoading = true;
          if (!this.$refs.upload.active) {
            new ImageCompressor(newFile.file, {
              quality: 0.9,
              maxHeight: 1200,
              success: (result) => {
                // Successfully deleted the error to write the new file
                this.$refs.upload.update(newFile, {
                  file: result,
                  error: "",
                  size: result.size,
                  type: result.type,
                });
                setTimeout(() => {
                  this.$refs.upload.active = true;
                }, 200);
              },
            });
          }
        }
      }
    },
    inputFilter(newFile, oldFile, prevent) {
      if (newFile && !oldFile) {
        if (!/\.(gif|jpg|jpeg|png|webp)$/i.test(newFile.name)) {
          this.alert("Your choice is not a picture");
          return prevent();
        }
      }
      if (newFile && (!oldFile || newFile.file !== oldFile.file)) {
        newFile.url = "";
        const URL = window.URL || window.webkitURL;
        if (URL && URL.createObjectURL) {
          newFile.url = URL.createObjectURL(newFile.file);
        }
      }
    },
  },
  mounted() {
    ApiService.sadminApi.getCouncil(this.id).then((resp) => {
      this.council = resp.data;
      this.uploadUrl =
        apiUrl + "/api/uploadFile?notice&council_id=" + this.council.id;
    });
    if (this.new) {
      this.edit = true;
    }
    // this.$store.dispatch("logout", true);
  },
});
